import {Directive, forwardRef, OnInit} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn} from '@angular/forms';

/**
 * Custom validator that checks if at least one file was uploaded and processed
 */
// @dynamic
@Directive({
  selector: 'lib-exc-file-input[excUploadRequired][ngModel],' +
    'lib-exc-file-input[excUploadRequired][formControl],' +
    'lib-exc-file-input[excUploadRequired][formControlName]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ExcUploadRequiredValidator),
      multi: true
    }
  ]
})
export class ExcUploadRequiredValidator implements OnInit, Validator {

  validator: (control: AbstractControl) => ValidationErrors | null;

  /**
   * Checks if at least one file was selected and that at least one file is processed completely (not loading)
   */
  public static required(): ValidatorFn {
    return function (control: AbstractControl): ValidationErrors | null {
      if (Array.isArray(control.value) && control.value.length > 0 && !control.value.some(file => file.isLoading)) {
        return null;
      } else {
        return {
          uploadRequired: true
        };
      }
    };
  }

  ngOnInit() {
    this.validator = ExcUploadRequiredValidator.required();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validator(control);
  }
}
